import { useTranslation } from 'react-i18next';
import { supportedLanguages } from '../i18n';
import { cn } from '../lib/cn';

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const current = (i18n.resolvedLanguage ?? i18n.language).slice(0, 2);

  return (
    <div
      role="group"
      aria-label={t('footer.language')}
      className="flex items-center gap-1 text-xs uppercase tracking-[0.2em]"
    >
      {supportedLanguages.map((lng) => {
        const isActive = current === lng;
        return (
          <button
            key={lng}
            type="button"
            onClick={() => {
              if (!isActive) void i18n.changeLanguage(lng);
            }}
            aria-pressed={isActive}
            className={cn(
              'px-1.5 py-1 transition-opacity',
              isActive ? 'opacity-100' : 'opacity-50 hover:opacity-100',
            )}
          >
            {lng}
          </button>
        );
      })}
    </div>
  );
}
